export const staticSuffix = 'checkout'; // eslint-disable-line
export const micrositeName = 'yoda-microsite-checkout';
export const esiHeaderRequiredRoutes = [];
export const isContextHeadersRequired = true;
export const app = {
    logTag: 'MICROSITE:CHECKOUT',
};
export const configServerSettingsFlag = true;
